import { createFileRoute } from "@tanstack/react-router";
import { RegisterForm } from "@/features/auth/RegisterForm";
import { useInvitedEmail } from "@/features/seat-orders/useInvitedEmail";

export const Route = createFileRoute("/_marketing/register")({
  component: RegisterPage,
  // Where to go once signed in. It is passed on to the login page, so it survives register → verify →
  // log in; the login page sanitizes it before use.
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
});

function RegisterPage() {
  const { redirect } = Route.useSearch();
  // Signing up to take up a seat invite (LMS-188): pre-fill the address it was sent to, held in app state only.
  const invitedEmail = useInvitedEmail(redirect);

  return (
    <div className="flex flex-1 items-center justify-center px-4 py-16">
      <RegisterForm redirect={redirect} invitedEmail={invitedEmail} />
    </div>
  );
}
